import { ReactNode } from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/lib/router-compat";

interface CountrySectionProps {
  country: "nicaragua" | "costa-rica";
  title: string;
  subtitle: string;
  children: ReactNode;
  linkHref: string;
  linkText: string;
}

const CountrySection = ({ country, title, subtitle, children, linkHref, linkText }: CountrySectionProps) => {
  const flagEmoji = country === "nicaragua" ? "🇳🇮" : "🇨🇷";
  const countryColor = country === "nicaragua" ? "text-nicaragua" : "text-costa-rica";
  
  return (
    <section className="w-full">
      <div className="text-center mb-6">
        <h2 className={`text-3xl md:text-4xl font-bold ${countryColor} flex items-center justify-center gap-3 mb-2`}>
          <span>{flagEmoji}</span>
          {title}
        </h2>
        <p className="text-muted-foreground">{subtitle}</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        {children}
      </div>

      <div className="text-center">
        <Button asChild size="lg" className="bg-foreground text-background hover:bg-foreground/90">
          <Link to={linkHref}>{linkText}</Link>
        </Button>
      </div>
    </section>
  );
};

export default CountrySection;
